import * as Actions from "./actions";
import * as Mutations from "./mutations";

const importMaps = {
  namespaced: true,
  state: {
    list: Actions.getOrCreateLocalStorageMaps(),
    addedList: []
  },

  getters: {
  },
  actions: {
    testConnection: Actions.testConnection,
    load: Actions.load,
    addToEarth: Actions.addToEarth,
    importMap: Actions.importMap,
    removeFromEarth: Actions.removeFromEarth,
    deleteMap: Actions.deleteMap
  },
  mutations: {
    setMaps: Mutations.setMaps,
    addToEarth: Mutations.addToEarth,
    importMap: Mutations.importMap,
    removeFromEarth: Mutations.removeFromEarth,
    deleteMap: Mutations.deleteMap
  },
};
export default importMaps;
